/**
 * Application Routes
 *
 * Static-site-generation entry: exports a route array consumed by
 * `ViteReactSSG` in `main.jsx`. ViteReactSSG provides the Router and
 * HelmetProvider, so we only describe the route tree here. Detail routes are
 * generated from the data files so each one is prerendered.
 */

import Layout from './components/layout/Layout'
import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import ServicesPage from './pages/ServicesPage'
import ServiceDetailPage from './pages/ServiceDetailPage'
import ConditionsHubPage from './pages/ConditionsHubPage'
import ConditionPage from './pages/ConditionPage'
import PractitionerPage from './pages/PractitionerPage'
import FaqPage from './pages/FaqPage'
import VisitPage from './pages/VisitPage'
import ContactPage from './pages/ContactPage'
import BlogPage from './pages/BlogPage'
import BlogPostPage from './pages/BlogPostPage'
import ExerciseLibraryPage from './pages/ExerciseLibraryPage'
import NotFound from './pages/NotFound'
import { servicePages } from './data/servicePages'
import { conditions } from './data/conditions'
import { teamMembers } from './data/team'
import { blogPosts } from './data/blog'

export const routes = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'about', element: <AboutPage /> },
      { path: 'services', element: <ServicesPage /> },
      ...servicePages.map((s) => ({
        path: `services/${s.slug}`,
        element: <ServiceDetailPage slug={s.slug} />,
      })),
      { path: 'conditions', element: <ConditionsHubPage /> },
      ...conditions.map((c) => ({
        path: `conditions/${c.slug}`,
        element: <ConditionPage slug={c.slug} />,
      })),
      ...teamMembers.map((m) => ({
        path: `team/${m.slug}`,
        element: <PractitionerPage slug={m.slug} />,
      })),
      { path: 'faq', element: <FaqPage /> },
      { path: 'visit', element: <VisitPage /> },
      { path: 'contact', element: <ContactPage /> },
      { path: 'blog', element: <BlogPage /> },
      ...blogPosts.map((p) => ({
        path: `blog/${p.slug}`,
        element: <BlogPostPage slug={p.slug} />,
      })),
      { path: 'exercise-library', element: <ExerciseLibraryPage /> },
      { path: '404', element: <NotFound /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]
